document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    // Legge i dati dei prodotti dal JSON element inserito dal server
    var dataEl = document.getElementById('hcProductsData');
    if (!dataEl) return;
    var productsData = JSON.parse(dataEl.textContent);

    // Carrello locale
    var cart = {};

    // Riferimenti DOM
    var panel           = document.getElementById('panelHelpCenter2');
    var listaContainer  = document.querySelector('#panelHelpCenter2 .listaContainer');
    var totaleContainer = document.getElementById('totaleContainer');
    var totalePrezzo    = document.getElementById('totalePrezzo');
    var submitBtn       = document.getElementById('hcSubmitBtn');
    var panelContent    = document.getElementById('panelContent');
    var toggleBtn       = document.getElementById('togglePanelBtn');

    if (!panel) return;

    // ─── Regole di auto-bundle ────────────────────────────────────────────────
    // Ciascuna regola sostituisce un set di prodotti singoli con il bundle
    // corrispondente quando tutti sono presenti nel carrello.
    // Le regole vengono filtrate in base ai prodotti disponibili nella pagina.
    var AUTO_BUNDLE_RULES = [
        // HelpCenter V2: analisi + valutazione → comprendere_pkg
        {
            items:  ['hc_analisi', 'hc_valutazione'],
            result: 'hc_comprendere_pkg'
        },
        // HelpCenter V2: comprendere_pkg + partecipare → pkg
        {
            items:  ['hc_comprendere_pkg', 'hc_partecipare'],
            result: 'hc_pkg'
        },
        // SupportoTecnico: tutti i singoli → pkg_professionista
        {
            items:  ['hc_verificare_rep', 'hc_verificare', 'hc_redigere', 'hc_calcolare', 'hc_concludere_due', 'hc_concludere_cdu', 'hc_concludere', 'hc_concludere_plus'],
            result: 'hc_pkg_professionista'
        }
    ].filter(function (rule) {
        return rule.items.every(function (id) { return !!productsData[id]; }) &&
               !!productsData[rule.result];
    });

    // ─── UI: stato card ───────────────────────────────────────────────────────

    function setCardSelected(cardId, selected) {
        var card = document.getElementById(cardId);
        if (!card) return;
        var btn = card.querySelector('.hc_pacchetti_btn');
        if (!btn) return;
        var icon  = btn.querySelector('.material-symbols-outlined');
        var label = btn.querySelector('span:last-child');
        if (selected) {
            btn.classList.remove('btn-primary', 'btn-light');
            btn.classList.add('btn-secondary');
            if (icon)  icon.textContent  = 'check_circle';
            if (label) label.textContent = 'Selezionato';
        } else {
            btn.classList.remove('btn-secondary');
            btn.classList.add(btn.dataset.originalClass || 'btn-primary');
            if (icon)  icon.textContent  = 'check';
            if (label) label.textContent = 'Aggiungi';
        }
    }

    // ─── UI: aggiorna panel ───────────────────────────────────────────────────

    function updatePanel() {
        var keys = Object.keys(cart);
        if (keys.length === 0) {
            panel.classList.add('d-none');
            listaContainer.innerHTML = '';
            totaleContainer.style.display = 'none';
            submitBtn.style.display = 'none';
            return;
        }

        panel.classList.remove('d-none');

        var listHtml = '';
        var total = 0;
        var IVA = 1.22;

        keys.forEach(function (cardId) {
            var product = cart[cardId];
            var ivaLabel = product.noIva ? 'esente IVA' : '+ IVA';
            var removeBtn = product.autoAdded
                ? ''
                : '<button type="button" class="btn btn-sm btn-link text-decoration-none p-0 hc-remove-btn" ' +
                      'data-card-id="' + cardId + '" aria-label="Rimuovi">' +
                      '<span class="material-symbols-outlined text-muted" style="font-size:18px">close</span>' +
                  '</button>';
            listHtml +=
                '<div class="d-flex justify-content-between align-items-start gap-2 mb-2">' +
                    '<div class="flex-grow-1">' +
                        '<div class="small fw-bold">' + product.name + '</div>' +
                        '<div class="small text-muted">&euro; ' + product.price + ' ' + ivaLabel + '</div>' +
                    '</div>' +
                    removeBtn +
                '</div>';
            total += product.noIva ? product.price : product.price * IVA;
        });

        var totalRounded = Math.round(total * 100) / 100;
        var totalStr = Number.isInteger(totalRounded)
            ? totalRounded
            : totalRounded.toFixed(2).replace('.', ',');
        listaContainer.innerHTML = listHtml;
        totalePrezzo.textContent = '\u20ac ' + totalStr;
        totaleContainer.style.display = '';
        submitBtn.style.display = '';

        listaContainer.querySelectorAll('.hc-remove-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                removeFromCart(this.dataset.cardId);
            });
        });
    }

    // ─── UI: aggiorna stato bottone hc_concludere_plus ───────────────────────

    function updateConcluderePlusButton() {
        var concluderePlusCard = document.getElementById('hc_concludere_plus');
        if (!concluderePlusCard) return;

        var concluderePlusBtn = concluderePlusCard.querySelector('.hc_pacchetti_btn');
        if (!concluderePlusBtn) return;

        // Abilita il bottone se hc_concludere o hc_pkg_professionista sono nel carrello
        var shouldEnable = cart['hc_concludere'] || cart['hc_pkg_professionista'];

        if (shouldEnable) {
            concluderePlusBtn.classList.remove('disabled');
            concluderePlusBtn.removeAttribute('aria-disabled');
            concluderePlusBtn.style.pointerEvents = '';
            concluderePlusBtn.style.opacity = '';
        } else {
            concluderePlusBtn.classList.add('disabled');
            concluderePlusBtn.setAttribute('aria-disabled', 'true');
            concluderePlusBtn.style.pointerEvents = 'none';
            concluderePlusBtn.style.opacity = '0.65';
            // Rimuove hc_concludere_plus dal carrello se presente
            if (cart['hc_concludere_plus']) {
                delete cart['hc_concludere_plus'];
                setCardSelected('hc_concludere_plus', false);
            }
        }
    }

    // ─── Logica carrello ──────────────────────────────────────────────────────

    function syncBolloDigitale() {
        var bollo = productsData['hc_bollo_digitale'];
        if (!bollo) return;
        var triggerInCart = !!(cart['hc_partecipare'] || cart['hc_pkg']);
        if (triggerInCart && !cart['hc_bollo_digitale']) {
            cart['hc_bollo_digitale'] = bollo;
        } else if (!triggerInCart && cart['hc_bollo_digitale']) {
            delete cart['hc_bollo_digitale'];
        }
    }

    function addToCart(cardId) {
        var product = productsData[cardId];
        if (!product) return;

        // Verifica dipendenze (campo "requires" nel prodotto)
        if (product.requires && !cart[product.requires]) {
            return;
        }

        // Risolve i conflitti
        if (product.conflicts) {
            product.conflicts.forEach(function (conflictId) {
                if (cart[conflictId]) {
                    delete cart[conflictId];
                    setCardSelected(conflictId, false);
                }
            });
        }

        cart[cardId] = product;
        setCardSelected(cardId, true);

        // Applica regole di auto-bundle attive per questa pagina
        AUTO_BUNDLE_RULES.forEach(function (rule) {
            if (cart[rule.result]) return;
            var allPresent = rule.items.every(function (id) { return !!cart[id]; });
            if (allPresent) {
                rule.items.forEach(function (id) {
                    delete cart[id];
                    setCardSelected(id, false);
                });
                var bundle = productsData[rule.result];
                if (bundle) {
                    cart[rule.result] = bundle;
                    setCardSelected(rule.result, true);
                }
            }
        });

        syncBolloDigitale();
        updateConcluderePlusButton();
        updatePanel();
    }

    function removeFromCart(cardId) {
        delete cart[cardId];
        setCardSelected(cardId, false);

        // Rimozione a cascata: rimuove i prodotti che dipendono da questo
        Object.keys(productsData).forEach(function (id) {
            if (productsData[id].requires === cardId && cart[id]) {
                delete cart[id];
                setCardSelected(id, false);
            }
        });

        syncBolloDigitale();
        updateConcluderePlusButton();
        updatePanel();
    }

    function toggleCart(cardId) {
        if (cart[cardId]) {
            removeFromCart(cardId);
        } else {
            addToCart(cardId);
        }
    }

    // ─── Submit form ──────────────────────────────────────────────────────────

    var orderForm = document.getElementById('hcOrderForm');
    if (orderForm) {
        orderForm.addEventListener('submit', function (e) {
            e.preventDefault();
            var products = Object.keys(cart).map(function (cardId) { return cart[cardId]; });
            document.getElementById('hcProductsJson').value = JSON.stringify(products);
            this.submit();
        });
    }

    // ─── Bind bottoni "Aggiungi" ──────────────────────────────────────────────

    document.querySelectorAll('.hc_pacchetti').forEach(function (card) {
        if (!card.id) return;
        var btn = card.querySelector('.hc_pacchetti_btn');
        if (!btn) return;
        btn.dataset.originalClass = btn.classList.contains('btn-light') ? 'btn-light' : 'btn-primary';
        btn.addEventListener('click', function () {
            if (this.classList.contains('disabled')) return;
            toggleCart(card.id);
        });
    });

    // ─── Toggle panel (collassa/espandi) ─────────────────────────────────────

    if (toggleBtn && panelContent) {
        var panelHeaderInfo = document.getElementById('panelHeaderInfo');
        toggleBtn.addEventListener('click', function () {
            var hidden = panelContent.classList.toggle('d-none');
            if (panelHeaderInfo) panelHeaderInfo.classList.toggle('d-none');
            var icon = this.querySelector('.material-symbols-outlined');
            if (icon) icon.textContent = hidden ? 'expand_more' : 'expand_less';
        });
    }
});
